import React, { Component } from 'react';
import { Grid, Row, Col, Table, ButtonToolbar, Button } from 'react-bootstrap';

import { PropTypes } from 'prop-types';
import { DownloadMultipleDocumentsForm } from './DownloadMultipleDocumentsForm';
import { PaginationBuilder } from '../../PaginationBuilder';
import { DownloadLinkHelper } from '../../helpers/DownloadLinkHelper';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchHelper } from '../../helpers/SearchHelper';
import { DrawCommand } from '../commands/DrawCommand';
import { AddOnsFilesCommand, AddOnsBusSchedCommand } from '../../addOns/commands/AddOnsCommand';
import { DownloadCommand } from '../../files/commands/DownloadCommand';
import { LoadingSpinner } from '../../LoadingSpinner';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { TitleRow } from '../../TitleRow';
import { SearchBar } from '../../SearchBar';
import { TableButton } from '../../TableButton';
import { SortIndicator } from '../../SortIndicator';
import { AddOnsHelper } from '../../helpers/AddOnsHelper';
import { EditionsCommand } from '../commands/EditionsCommand';

import Select from "react-select";

export class ListSchedules extends Component {
    static contextTypes = {
        selectApp: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            addOns: [],
            table: {
                data: [],
                page: 1,
                elementsPerPage: 10,
                filter: ""
            },
            form: {
                documents: [],
                network: undefined,
            },
            commands: {
                draw: new DrawCommand(),
                download: new DownloadCommand(),
                addOnsFiles: new AddOnsFilesCommand(),
                addOnsBusSched: new AddOnsBusSchedCommand(),
                editionsCommand: new EditionsCommand()
            },
            actions: {
                isLoading: true,
                isLoadingEditions: true,
                isLoadingAddOns: true,
                isUpdating: false,
                isExecutingAddOn: false,
                isDeleting: false,
                isSelectingMultipleDocuments: false,
                isDownloadingMultipleDocuments: false,
                isDeletingMultipleDocuments: false,
            },
            render: {
                addOn: "",
                showDownloadMultipleDocumentsForm: false,
                sort: {
                    property: "generationDate",
                    type: "descending"
                },
                editions: undefined,
                cachedDocuments: {},
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            },
        };
    }

    componentDidMount() {
        this.context.selectApp('bussched', false);
        this.getAddOns();
        this.getEditions();
    }

    getDocuments(networkId) {
        const { commands, actions } = this.state;

        actions.isLoading = true;
        commands.draw.list(
            networkId,
            (a) => this.successCallback(a),
            (a) => this.errorCallback(a, "isLoading", true)
        );

        this.setState({
            actions: actions
        });
    }

    getAddOns() {
        const { commands, actions } = this.state;

        actions.isLoadingAddOns = true;
        commands.addOnsFiles.get(
            (a) => this.addOnsSuccessCallback(a),
            () => this.addOnsErrorCallback()
        );
        commands.addOnsBusSched.get(
            (a) => this.addOnsSuccessCallback(a),
            () => this.addOnsErrorCallback()
        );
    }

    getEditions() {
        const { actions, commands } = this.state;

        actions.isLoadingEditions = true;

        this.setState({
            actions: actions
        });

        commands.editionsCommand.getNetworks(
            (a) => this.editionsSuccessCallback(a),
            (a) => this.editionsErrorCallback(a)
        );
    }

    // ---------------------------

    editionsSuccessCallback(result) {
        const { actions, form, render } = this.state;
        actions.isLoadingEditions = false;

        if (Array.isArray(result) && result.length > 0) {
            result.reverse();
            this.getDocuments(result[0].id);

            this.setState({
                render: {
                    ...render,
                    editions: result
                },
                form: {
                    ...form,
                    network: result[0]
                },
                actions: actions
            });
        }
    }

    successCallback(result) {
        const { table, actions, form, render } = this.state;
        const totalPages = PaginationHelper.getTotalPages(result.length, table.elementsPerPage);

        actions.isLoading = false;
        table.data = result;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }


        let documentsDictionary = { ...render.cachedDocuments };
        if (undefined !== form.network.id) {
            documentsDictionary[form.network.id] = result;
        }

        // Update table
        this.setState({
            table: table,
            actions: actions,
            render: {
                ...render,
                cachedDocuments: documentsDictionary
            }
        });
    }

    addOnsSuccessCallback(result) {
        const { actions, addOns } = this.state;

        actions.isLoadingAddOns = false;

        result.forEach((addOn) => addOns.push(addOn));

        this.setState({
            actions: actions,
            addOns: addOns
        });
    }

    downloadSuccessCallback(blob, name, action) {
        var FileSaver = require('file-saver');
        FileSaver.saveAs(blob, name);

        if (undefined !== action) {
            const { actions } = this.state;

            actions[action] = false;

            this.setState({
                actions: actions
            });
        }
    }

    operationSuccessCallback(messageReceived, updateAction, updateDocuments = true, callback = undefined) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        if (updateDocuments) {
            this.getDocuments();
        }

        if ("function" === typeof callback) {
            callback();
        }
    }

    editionsErrorCallback(message) {
        const { actions } = this.state;
        actions.isLoadingEditions = false;

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    errorCallback(message, action, reset = false) {
        const { table, actions } = this.state;
        actions[action] = false;

        if (reset) {
            table.page = 1;
            table.data = [];
        }

        this.setState({
            table: table,
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    addOnsErrorCallback() {
        const { actions } = this.state;

        actions.isLoadingAddOns = false;

        this.setState({
            actions: actions
        });
    }

    operationErrorCallback(messageReceived, updateAction) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // -----------------------

    onSelectMultipleDocumentsClick(state) {
        const { actions } = this.state;

        actions.isSelectingMultipleDocuments = state;

        this.setState({
            actions: actions
        });
    }

    onDeleteMultipleDocumentsClick() {
        const { table, form } = this.state;

        const messageDocuments = form.documents.map(document => {
            const data = table.data.find(x => x.fileName === document);
            if (undefined === data) {
                return null;
            }

            return (
                <li>{`${data.name} [${data.code}] gerados a ${data.generationDate}`}</li>
            );
        });

        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: <div><p>Tem a certeza que pretende eliminar os documentos:</p>{messageDocuments}</div>,
                style: "warning",
                icon: "alert",
                argument: {
                    operation: "delete-multiple",
                    filesName: form.documents.slice()
                }
            }
        });
    }

    onDownloadMultipleDocumentsClick() {
        const { render } = this.state;

        render.showDownloadMultipleDocumentsForm = true;

        this.setState({
            render: render
        });
    }

    onRowClick(data) {
        const { form } = this.state;

        if (form.documents.includes(data.fileName)) {
            form.documents = form.documents.filter(document => document !== data.fileName);
        }
        else {
            form.documents.push(data.fileName);
        }

        this.setState({
            form: form
        });
    }

    onDeleteClick(data) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar os documentos para ${data.name} [${data.code}] gerados a ${data.generationDate}`,
                style: "warning",
                icon: "alert",
                argument: {
                    operation: "delete",
                    fileName: data.fileName
                }
            }
        });
    }

    onFixedClick(data) {
        this.setState({
            dialog: {
                show: true,
                title: "Confirmação",
                message: `Confirma que foi afixado o documento da paragem ${data.name} [${data.code}] gerado a ${data.generationDate}?`,
                style: "warning",
                icon: "question-sign",
                argument: {
                    operation: "fixed",
                    fileName: data.fileName
                }
            }
        });
    }

    onUnfixedClick(data) {
        this.setState({
            dialog: {
                show: true,
                title: "Confirmação",
                message: `Confirma que o documento da paragem ${data.name} [${data.code}] gerado a ${data.generationDate} não está afixado?`,
                style: "warning",
                icon: "question-sign",
                argument: {
                    operation: "unfixed",
                    fileName: data.fileName
                }
            }
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ''
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            const { commands } = this.state;

            switch (argument.operation) {
                case "fixed":
                    actions.isUpdating = true;
                    commands.draw.fixed(
                        argument.fileName,
                        (a) => this.operationSuccessCallback(a, "isUpdating"),
                        (a) => this.operationErrorCallback(a, "isUpdating")
                    );
                    break;

                case "unfixed":
                    actions.isUpdating = true;
                    commands.draw.unfixed(
                        argument.fileName,
                        (a) => this.operationSuccessCallback(a, "isUpdating"),
                        (a) => this.operationErrorCallback(a, "isUpdating")
                    );
                    break;

                case "delete":
                    actions.isDeleting = true;
                    commands.draw.delete(
                        argument.fileName,
                        (a) => this.operationSuccessCallback(a, "isDeleting"),
                        (a) => this.operationErrorCallback(a, "isDeleting")
                    );
                    break;

                case "delete-multiple":
                    actions.isDeletingMultipleDocuments = true;
                    commands.draw.deleteMultiple(
                        argument.filesName,
                        (a) => this.operationSuccessCallback(a, "isDeletingMultipleDocuments", true, () => this.onCleanDocuments()),
                        (a) => this.operationErrorCallback(a, "isDeletingMultipleDocuments")
                    );
                    break;

                default: // DO NOTHING
                    break;
            }
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // -----------------------

    onChangePage(pageNumber) {
        const { table } = this.state;
        table.page = pageNumber;

        this.setState({
            table: table
        });
    }

    onChangeElements(element) {
        const { form, render } = this.state;

        this.onCleanDocuments();

        if (undefined !== render.cachedDocuments[element.id]) {
            this.successCallback(render.cachedDocuments[element.id]);
        }
        else {
            this.getDocuments(element.id);
        }

        this.setState({
            form: {
                ...form,
                network: element
            }
        });
    }

    onChangeElementsPerPage(elementsPerPage) {
        const { table } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, elementsPerPage);

        table.elementsPerPage = elementsPerPage;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        this.setState({
            table: table
        });
    }

    onChangeSort(property) {
        const { render } = this.state;

        render.sort.type = render.sort.property === property && "ascending" === render.sort.type ? "descending" : "ascending";
        render.sort.property = property;

        this.setState({
            render: render
        });
    }

    onSearch(filter) {
        const { table } = this.state;

        table.filter = filter;

        this.setState({
            table: table
        });
    }

    onCleanDocuments() {
        const { form } = this.state;

        form.documents = [];

        this.setState({
            form: form
        });
    }

    onSelectFilteredDocuments() {
        const { table, form } = this.state;

        form.documents = this.filterData(table)
            .map(data => data.fileName);

        this.setState({
            form: form
        });
    }

    onStartDownload(format, name) {
        const { commands } = this.state;

        commands.download.downloadBusSched(format, '',
            (a) => this.downloadSuccessCallback(a, name),
            (a) => this.errorCallback(a, "isLoading")
        );
    }

    onDownloadMultipleDocuments(downloadSvg = true, downloadPng = true, downloadPdf = true) {
        const { table, form, actions, commands } = this.state;
        const documents = [];

        form.documents.forEach(document => {
            const file = table.data.find(data => data.fileName === document);
            if (undefined === file) {
                return;
            }

            if (downloadSvg && undefined !== file.formatSvg && null !== file.formatSvg && "" !== file.formatSvg) {
                documents.push(file.formatSvg);
            }

            if (downloadPng && undefined !== file.formatPng && null !== file.formatPng && "" !== file.formatPng) {
                documents.push(file.formatPng);
            }

            if (downloadPdf && undefined !== file.formatPdf && null !== file.formatPdf && "" !== file.formatPdf) {
                documents.push(file.formatPdf);
            }
        });

        actions.isDownloadingMultipleDocuments = true;
        this.setState({
            actions: actions
        });

        commands.download.downloadMultipleBusSched(documents, '', form.network.id,
            (a) => this.downloadSuccessCallback(a, "Horários.zip", "isDownloadingMultipleDocuments"),
            (a) => this.errorCallback(a, "isDownloadingMultipleDocuments"))
    }

    onExecuteAddOn(addOn, label, parameters, command) {
        const { actions, render } = this.state;

        render.addOn = label;
        actions.isExecutingAddOn = true;
        command.execute(
            addOn,
            label,
            parameters,
            (a) => this.operationSuccessCallback(a, "isExecutingAddOn", false),
            (a) => this.operationErrorCallback(a, "isExecutingAddOn")
        );

        this.setState({
            actions: actions,
            render: render
        });
    }

    onExecuteUploadPdfAddOn(addOn, label, document) {
        const { commands } = this.state;
        this.onExecuteAddOn(addOn, label, { document: document }, commands.addOnsFiles);
    }

    onExecuteUploadMultiplePdfsAddOn(addOn, label) {
        const { table, form, commands } = this.state;

        const documents = table.data
            .filter(data => undefined !== data.formatPdf && null !== data.formatPdf && "" !== data.formatPdf)
            .filter(data => form.documents.some(document => document === data.fileName))
            .map(data => data.formatPdf);

        this.onExecuteAddOn(addOn, label, { documents: documents }, commands.addOnsFiles);
    }

    onConfirmDownloadMultipleDocuments(data) {
        this.onDownloadMultipleDocuments(data.downloadSvg, data.downloadPng, data.downloadPdf);
        this.onCancelDownloadMultipleDocuments();
    }

    onCancelDownloadMultipleDocuments() {
        const { render } = this.state;

        render.showDownloadMultipleDocumentsForm = false;

        this.setState({
            render: render
        });
    }

    // ---------------------------

    filterData(table) {
        return SearchHelper.search({
            filter: table.filter,
            data: table.data,
            fields: ["type", "code", "name", "orientation", "referenceDate", "generationDate"]
        });
    }

    getTableRowClassName(isSelectingMultipleDocuments, selectedDocuments, data) {
        return isSelectingMultipleDocuments ?
            `busched selectable ${selectedDocuments.includes(data.fileName) ? "checked" : ""}` :
            "";
    }

    // ---------------------------

    sortDocuments(sort, a, b) {
        let aValue = a[sort.property];
        let bValue = b[sort.property];

        if ("object" === typeof aValue) {
            aValue = undefined !== aValue.left ? aValue.left : aValue.right;
        }

        if ("object" === typeof bValue) {
            bValue = undefined !== bValue.left ? bValue.left : bValue.right;
        }

        if (aValue === bValue) {
            return 0;
        }

        const output = aValue < bValue ? -1 : 1;

        if ("descending" === sort.type) {
            return output * -1;
        }

        return output;
    }

    // ---------------------------

    renderDownloadMultipleDocumentsForm(isToShow) {
        if (!isToShow) {
            return null;
        }

        return (
            <DownloadMultipleDocumentsForm
                title="Tipos de documentos a descarregar"
                onConfirm={(a) => this.onConfirmDownloadMultipleDocuments(a)}
                onCancel={() => this.onCancelDownloadMultipleDocuments()} />
        );
    }

    renderLoading(isWaiting) {
        if (isWaiting) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderSortIndicator(property, sort) {
        if (property !== sort.property) {
            return (
                <SortIndicator order="none" />
            );
        }

        return (
            <SortIndicator order={sort.type} />
        );
    }

    renderUploadPdfAddOn(format) {
        if (undefined === format) {
            return null;
        }

        const { addOns } = this.state;

        if (!Array.isArray(addOns)) {
            return null;
        }

        const addOn = addOns.find(addOn => addOn.enabled && "UploadBusSchedPdf" === addOn.name);
        if (undefined === addOn) {
            return null;
        }

        return (
            <TableButton
                marginRight
                icon={AddOnsHelper.getIcon(addOn.icon)}
                onClick={() => this.onExecuteUploadPdfAddOn(addOn.name, addOn.label, format)}
                title={addOn.label} />
        );
    }

    renderDownloadLink(format, downloadName, extention) {
        if (undefined === format || null === format || "" === format) {
            return null;
        }

        return (
            <TableButton
                icon="icon-download"
                onClick={() => this.onStartDownload(format, DownloadLinkHelper.getDownloadFileName(format, downloadName, extention))}
                title={`Transferir ${extention.toUpperCase()}`}
            />
        );
    }

    renderFixedButton(data) {
        if (data.isFixed) {
            return (
                <TableButton marginRight icon="icon-error" title="Marcar como não Afixado" onClick={() => this.onUnfixedClick(data)} /> //icon-error is placeholder
            );
        }

        return (
            <TableButton marginRight icon="icon-select" title="Marcar como Afixado" onClick={() => this.onFixedClick(data)} />
        );
    }

    renderFixed(data) {
        if (data.isFixed) {
            return (
                <TableButton marginRight icon="icon-ok" title="Afixado" />
            );
        }

        return null;
    }

    renderReferenceDate(presentReferenceDate, referenceDate) {
        if (!presentReferenceDate) {
            return null;
        }

        const value = undefined === referenceDate || null === referenceDate || "" === referenceDate ?
            "-----" :
            referenceDate;

        return (
            <td>
                {value}
            </td>
        );
    }

    renderTableLine(generatorConfigs, idx, data, isSelectingMultipleDocuments, selectedDocuments, onRowClickCallback) {
        return (
            <tr className={this.getTableRowClassName(isSelectingMultipleDocuments, selectedDocuments, data)} onClick={onRowClickCallback} key={`layout-${idx}`}>
                <td>{data.type}</td>
                <td>{data.code}</td>
                <td>{data.name}</td>
                <td>{data.orientation}</td>
                {this.renderReferenceDate(generatorConfigs.presentReferenceDate, data.referenceDate)}
                <td>{data.generationDate}</td>
                <td>{this.renderFixed(data)}</td>
                <td>{this.renderDownloadLink(data.formatSvg, data.downloadName, "svg")}</td>
                <td>{this.renderDownloadLink(data.formatPng, data.downloadName, "png")}</td>
                <td>{this.renderDownloadLink(data.formatPdf, data.downloadName, "pdf")}</td>
                <td>
                    <ButtonToolbar className="pull-right btn-toolbar">
                        {this.renderUploadPdfAddOn(data.formatPdf)}
                        {this.renderFixedButton(data)}
                        <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.onDeleteClick(data)} />
                    </ButtonToolbar>
                </td>
            </tr>
        );
    }

    renderTable(isWaiting, isSelectingMultipleDocuments) {
        const { generatorConfigs } = this.props;
        const { table, form, render } = this.state;

        const dataFiltered = this.filterData(table);
        const totalPages = PaginationHelper.getTotalPages(dataFiltered.length, table.elementsPerPage);
        const activePage = totalPages < table.page ? totalPages : table.page;
        const partialData = dataFiltered
            .sort((a, b) => this.sortDocuments(render.sort, a, b))
            .slice((activePage - 1) * table.elementsPerPage, activePage * table.elementsPerPage);

        return (
            <Grid className="margin-top-15" fluid>
                <Row>
                    <Col sm={12}>
                        <div className="table-loading">
                            <Table responsive striped hover>
                                <thead>
                                    <tr>
                                        <th className="sortable" onClick={() => this.onChangeSort("type")}>Tipo {this.renderSortIndicator("type", render.sort)}</th>
                                        <th className="sortable" onClick={() => this.onChangeSort("code")}>Código {this.renderSortIndicator("code", render.sort)}</th>
                                        <th className="sortable" onClick={() => this.onChangeSort("name")}>Nome {this.renderSortIndicator("name", render.sort)}</th>
                                        <th className="sortable" onClick={() => this.onChangeSort("orientation")}>Orientação {this.renderSortIndicator("orientation", render.sort)}</th>
                                        {generatorConfigs.presentReferenceDate ? <th className="sortable" onClick={() => this.onChangeSort("referenceDate")}>Data Referência {this.renderSortIndicator("referenceDate", render.sort)}</th> : null}
                                        <th className="sortable" onClick={() => this.onChangeSort("generationDate")}>Data Geração {this.renderSortIndicator("generationDate", render.sort)}</th>
                                        <th className="sortable" onClick={() => this.onChangeSort("isFixed")}>Afixado {this.renderSortIndicator("isFixed", render.sort)}</th>
                                        <th>SVG</th>
                                        <th>PNG</th>
                                        <th>PDF</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody className={isWaiting ? "overlay" : ""}>
                                    {
                                        partialData.map((data, idx) =>
                                            this.renderTableLine(generatorConfigs, idx, data, isSelectingMultipleDocuments, form.documents, isSelectingMultipleDocuments ? () => this.onRowClick(data) : null)
                                        )
                                    }
                                </tbody>
                            </Table>

                            <PaginationBuilder
                                currentPage={table.page}
                                elementsPerPage={table.elementsPerPage}
                                dataLength={dataFiltered.length}
                                onChangePage={(a) => this.onChangePage(a)}
                                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />

                            {this.renderLoading(isWaiting)}
                        </div>
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderUploadMultiplePdfsAddOn(hasAnyDocumentSelected) {
        const { addOns } = this.state;

        if (!Array.isArray(addOns)) {
            return null;
        }

        const addOn = addOns.find(addOn => addOn.enabled && "UploadMultipleBusSchedsPdf" === addOn.name);
        if (undefined === addOn) {
            return null;
        }

        const { actions } = this.state;

        if (actions.isExecutingAddOn) {
            return (
                <Button disabled={true}>{addOn.label}</Button>
            );
        }

        return (
            <Button onClick={() => this.onExecuteUploadMultiplePdfsAddOn(addOn.name, addOn.label)} disabled={!hasAnyDocumentSelected}>{addOn.label}</Button>
        );
    }

    renderDeleteMultipleDocumentsButton(hasAnyDocumentSelected) {
        const { actions } = this.state;

        if (actions.isDeletingMultipleDocuments) {
            return (
                <Button disabled={true}>A ELIMINAR...</Button>
            );
        }

        return (
            <Button onClick={() => this.onDeleteMultipleDocumentsClick()} disabled={!hasAnyDocumentSelected}>ELIMINAR</Button>
        );
    }

    renderDownloadMultipleDocumentsButton(hasAnyDocumentSelected) {
        const { actions } = this.state;

        if (actions.isDownloadingMultipleDocuments) {
            return (
                <Button disabled={true}>A DESCARREGAR...</Button>
            );
        }

        return (
            <Button onClick={() => this.onDownloadMultipleDocumentsClick()} disabled={!hasAnyDocumentSelected}>DESCARREGAR</Button>
        );
    }

    renderToolbarButtons() {
        const { actions } = this.state;

        if (actions.isSelectingMultipleDocuments) {
            const { form } = this.state;
            const hasAnyDocumentSelected = 0 < form.documents.length;

            return (
                <ButtonToolbar className="pull-right title-row-col-btns">
                    <Button onClick={() => this.onCleanDocuments()} disabled={!hasAnyDocumentSelected}>LIMPAR</Button>
                    <Button onClick={() => this.onSelectFilteredDocuments()}>SELECIONAR FILTRADOS</Button>
                    {this.renderUploadMultiplePdfsAddOn(hasAnyDocumentSelected)}
                    {this.renderDeleteMultipleDocumentsButton(hasAnyDocumentSelected)}
                    {this.renderDownloadMultipleDocumentsButton(hasAnyDocumentSelected)}
                    <Button onClick={() => this.onSelectMultipleDocumentsClick(false)}>CANCELAR</Button>
                </ButtonToolbar>
            );
        }

        return (
            <ButtonToolbar className="pull-right title-row-col-btns">
                <Button onClick={() => this.onSelectMultipleDocumentsClick(true)}>SELECIONAR</Button>
            </ButtonToolbar>
        );
    }

    renderNetworkSelect() {
        const { actions, form, render } = this.state;

        return (
            <Select
                className="custom-multiselect custom-multiselect-small"
                placeholder="Edição de Rede"
                noOptionsMessage={() => "Sem edições de rede"}
                onChange={(e) => this.onChangeElements(e)}
                options={render.editions}
                isMulti={false}
                isClearable={false}
                menuPlacement="auto"
                isDisabled={actions.isLoadingEditions}
                getOptionValue={value => value}
                getOptionLabel={label => label.name}
                value={form.network}
            />
        );
    }

    render() {
        const { actions, render, message, dialog } = this.state;
        return (
            <div>
                <TitleRow title="Horários" showSeparator={true} titleMd={12} childrenMd={12}>
                    <Col className="padding-0" xs={12} sm={12} md={3}>
                        {this.renderNetworkSelect()}
                    </Col>
                    <Col className="padding-0" xs={12} sm={9} md={6}>
                        {this.renderToolbarButtons()}
                    </Col>
                    <Col className="padding-0" xs={12} sm={3} md={3}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>

                {this.renderTable(actions.isLoading || actions.isLoadingAddOns || actions.isLoadingEditions || actions.isUpdating || actions.isDeleting, actions.isSelectingMultipleDocuments)}
                {this.renderDownloadMultipleDocumentsForm(render.showDownloadMultipleDocumentsForm)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleMessage
                    title={`A ${render.addOn}`}
                    message={<LoadingSpinner />}
                    style={`primary`}
                    icon="transfer"
                    show={actions.isExecutingAddOn}
                    small
                    noButtons />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/schedules/List.js